import { createAppAsyncThunk } from '@/redux/create-app-thunk';

export const getShippingModesForCartFromCheckout = createAppAsyncThunk(
  'checkout/getShippingModesForCart',
  async (_, { getState, rejectWithValue, extra: { checkoutService } }) => {
    try {
      const storeId = getState().root.storeConf.storeId;
      return await checkoutService.getShippingModesForCart({ storeId });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
